/* tslint:disable:max-line-length */
import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { Subscription } from 'rxjs';
import { LoginType, FORM_UTIL } from './login.util';
import { RutValidator } from 'ng2-rut';
import { AuthService } from 'src/app/shared/services/auth.service';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { productosPath, paths } from 'src/app/shared/helpers/constants';
import { SessionTimeoutService } from 'src/app/shared/services/session-timeout.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { getLocalStorage } from 'src/app/shared/helpers/helper';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass'],
})
export class LoginComponent implements OnInit, OnDestroy {
  form: FormGroup;
  tabActive: LoginType = LoginType.Broker;
  loginType = LoginType;
  invalidRequest = false;
  subscriptions: Subscription[] = [];
  isLoading = false;

  get isCustomerActive(): boolean {
    return this.tabActive === LoginType.Customer;
  }

  get isBrokerActive(): boolean {
    return this.tabActive === LoginType.Broker;
  }

  get rutControl(): FormControl {
    return this.form.get(FORM_UTIL.RUT) as FormControl;
  }

  get passwordControl(): FormControl {
    return this.form.get(FORM_UTIL.PASSWORD) as FormControl;
  }

  constructor(
    private formBuilder: FormBuilder,
    private rutValidator: RutValidator,
    private authService: AuthService,
    private router: Router,
    private idleTimeoutSvc: SessionTimeoutService,
    private sanitizer: DomSanitizer
  ) {
    this.setSafeUrl();
  }

  safeUrl: SafeResourceUrl;

  setSafeUrl() {
    const dynamicSanUrl =
      `${environment.keycloak.issuer}/auth/realms/VS-Clients/protocol/openid-connect/auth?client_id=account&redirect_uri=https%3A%2F%2F190.243.30.25%3A8543%2Fauth%2Frealms%2FVS-Clients%2Faccount%2Flogin-redirect&state=0%2Fb4ead940-ac22-4e02-9e74-b65e28213c08&response_type=code&scope=openid`;
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(dynamicSanUrl);
  }

  ngOnInit() {
    const tokenSso = getLocalStorage('token_sso');
    if (
      tokenSso != null &&
      tokenSso.tokenParsed != null &&
      !this.authService.isLoggedIn()
    ) {
      this.authService.authenticateSso(tokenSso);
      this.router.navigate(['productos']);
    }
    this.idleTimeoutSvc.setLogout(false);

    if (!!this.authService.isLoggedIn()) {
      this.router.navigate([productosPath.path]);
    }
    this.form = this.buildForm();
    const formSubscription = this.form.valueChanges.subscribe(
      _ => (this.invalidRequest = false)
    );
    this.subscriptions.push(formSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.map(_ => _.unsubscribe());
  }

  selectTab(type: LoginType): void {
    this.tabActive = type;
  }

  onSubmit() {
    const { rut, password } = this.form.value;
    const position = rut.length - 1;
    const username = rut.slice(0, position) + '-' + rut.slice(position);
    this.isLoading = true;
    this.authService
      .authenticate(username, password)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        _ => {
          this.authService
            .validateTempPass(this.authService.getRut())
            .subscribe(resTemp => {
              if (resTemp) {
                localStorage.setItem('claveTemporal', '0');
                this.router.navigate([paths.claveTemporal.path]);
              } else {
                this.router.navigate([productosPath.path]);
              }
            });
        },
        error => (this.invalidRequest = true)
      );
  }

  goToRecoveryPassword() {
    this.router.navigate([paths.recuperarClave.path]);
  }

  buildForm(): FormGroup {
    return this.formBuilder.group({
      [FORM_UTIL.RUT]: ['', [Validators.required, this.rutValidator]],
      [FORM_UTIL.PASSWORD]: ['', Validators.required],
    });
  }
}
